import React, { memo } from "react";
import { SidebarNode } from "./Node";

const jobTypes = [
  {
    Job_id: "dl",
    Name: "Data Load Job",
    type: 1,
  },
  {
    Job_id: "dqm",
    Name: "Data Quality Job",
    type: 4,
  },
  {
    Job_id: "mdm",
    Name: "Data Mastering Job",
    type: 5,
  },
  {
    Job_id: "dd",
    Name: "Data Deduplication Job",
    type: 6,
  },
  {
    Job_id: "de",
    Name: "Data Exchange Job",
    type: 2,
  },
  {
    Job_id: "dt",
    Name: "Data Transform Job",
    type: 3,
  },
  {
    Job_id: "nb",
    Name: "Notebook Job",
    type: 7,
  },
  {
    Job_id: "rj",
    Name: "Routing Job",
    type: 8,
  },
  {
    Job_id: "nj",
    Name: "Notification Job",
    type: 9,
  },
];

const Sidebar = () => (
  <aside style={{ minWidth: "130px" }}>
    {jobTypes.map((job) => (
      <SidebarNode key={job.Job_id} data={job} />
    ))}
    <SidebarNode data={{ type: "groupWidget", Name: "Group Widget" }} />
    <SidebarNode data={{ type: "widget", Name: "Note Widget" }} />
  </aside>
);

export default memo(Sidebar);
